import { ReactComponent as SolflareSvg } from "./Solflare_id5j73wBTF_1.svg";

const SolanaSolflareIcon = ({ props }) => (
  <SolflareSvg
    width="100%"
    height="100%"
    {...props}
    style={{ display: "block", ...(props?.style || {}) }}
  />
);

export default SolanaSolflareIcon;
